import { CloseOutlined, DownOutlined, SearchOutlined } from "@ant-design/icons"
import { Checkbox, Input, List, Flex, Spin, Tooltip } from "antd"
import axios from "../../axios-interceptor.js"
import { useEffect, useRef, useState, useLayoutEffect } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import "./style.css"
import { getUserDetailsByEmail, getUsersGroup, searchGroupByName, searchUserByEmail } from "../../services/WebServices.js"
import { getNameFromEmail } from "../../utils/getNameFromEmail.js"
import { getGroupsInSpace, getTenantGroups } from "../../services/WebServices.js"
import { showLoader } from "../../utils/showloader.js"
import { useDispatch } from "react-redux"
import { fetchSpaceUsers } from "../../redux/actions/userAction.js"
import { fetchSpaceSpecificUsers, fetchSpaceSpecificGroups, fetchSpaceSpecificUserPickers } from "../../redux/actions/userRoleGroupAction.js"
import { useTranslation } from "react-i18next"
import { getSpaceSpecificGroups, getSpaceSpecificUsers } from "../../utils/formsHelper.js"


const BACKEND_API = process.env.REACT_APP_BACKEND_API


function UserRoleDropdown(props) {
    const defaultSelectedOptions = {
        user: [],
        group: [],
        role: []
    }
    const { predefinedUsersList = null, predefinedGroupList = null, formElements = [], searchLocal = false, widgetInfo = {}, className = "", isDisabled = false, getAllGroups = false, onSelect, getSpaceUsers = false, selectedOptions = defaultSelectedOptions, placeholderElement, tabsRequired = null, headerStyle = {}, mode = "MULTIPLE", dropdownStyle = {}, hideDownArrow = false, enableResponsiveTags = false } = props
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false)
    const [userList, setUsersList] = useState([])
    const [filteredUserList, setFilteredUserList] = useState([])
    const [groupList, setGroupList] = useState([])
    const [filteredGroupList, setFilteredGroupList] = useState([])
    const [pickerList, setPickerList] = useState([])
    const [allFilteredUsersGroups, setAllFilteredUsersGroups] = useState([])

    const [roleList, setRoleList] = useState([])
    const [searchText, setSearchText] = useState("")
    const [showDropdown, setShowDropdown] = useState(false)
    const [activeTab, setActiveTab] = useState(tabsRequired ? tabsRequired[0] : "user")
    const { spaceId } = useParams()
    const { userInfo, userGroups } = useSelector((state) => state.user)
    const [displaySelected, setDisplaySelected] = useState([])
    const [visibleCount, setVisibleCount] = useState(0)
    const [hiddenCount, setHiddenCount] = useState(0)
    const customDropdownContainer = useRef(null)
    const labelContainerRef = useRef(null)
    const measureContainerRef = useRef(null)
    const plusMeasureRef = useRef(null)
    const abortControllerRef = useRef(null);

    const tenantId = localStorage.getItem("tenantId");
    const { fetchingSpecificUser, spaceSpecificUsers = [], fetchingSpecificGroups, spaceSpecificGroups = [], fetchingSpecificUserPickers, spaceSpecificUserPickers = [] } = useSelector((state) => state.userRoleGroupState)

    useEffect(() => {
        if (userInfo.userId) {
            dispatch(fetchSpaceSpecificUsers({ spaceId, userInfo }));
            dispatch(fetchSpaceSpecificUserPickers({ spaceId, userInfo }))
            dispatch(fetchSpaceSpecificGroups({ spaceId, userInfo }));
        }
    }, [userInfo])

    const getGlobalGroups = async () => {
        let groupResp = await getTenantGroups();
    }

    useEffect(() => {
        if (getSpaceUsers && !fetchingSpecificUser) {
            setUsersList(spaceSpecificUsers)
            setFilteredUserList(spaceSpecificUsers)
        }
    }, [getSpaceUsers, fetchingSpecificUser, spaceSpecificUsers])

    useEffect(() => {
        if (getAllGroups) {
            getGlobalGroups();
        }
    }, [getAllGroups])

    useEffect(() => {
        if (getSpaceUsers && !fetchingSpecificGroups && spaceSpecificGroups) {
            setFilteredGroupList(spaceSpecificGroups || [])
            setGroupList(spaceSpecificGroups)
        }
    }, [getSpaceUsers, fetchingSpecificGroups])

    useEffect(() => {
        if (!fetchingSpecificUserPickers && spaceSpecificUserPickers) {
            let reqPickers = [...spaceSpecificUserPickers]
            if (widgetInfo.widgetId) {
                reqPickers = reqPickers.filter(picker => picker.widgetId !== widgetInfo?.widgetId)
            }
            setPickerList(spaceSpecificUserPickers)
        }
    }, [fetchingSpecificUserPickers])


    let placeholder = props.placeholder || "Select"
    let width = "100%"
    const maxTagCount = Number.isInteger(props.maxTagCount) ? props.maxTagCount : 1

    useEffect(() => {
        let currentSelectedOptions = props.selectedOptions
        if (currentSelectedOptions) {
            let result = []
            let allTypes = Object.keys(currentSelectedOptions)
            allTypes.map(type => {
                let array2 = currentSelectedOptions[type].map(r => ({ type: type, display: r }))
                result = result.concat(array2)
            })
            setDisplaySelected(result)
        }
    }, [props.selectedOptions])

    const recalcVisibleCount = () => {
        const labelEl = labelContainerRef.current
        const measureEl = measureContainerRef.current
        if (!labelEl || !measureEl) return
        const tags = Array.from(measureEl.querySelectorAll('[data-measure-tag="true"]'))
        const total = tags.length
        if (total === 0) {
            setVisibleCount(0)
            setHiddenCount(0)
            return
        }
        const available = labelEl.clientWidth
        if (available <= 0) {
            setVisibleCount(0)
            setHiddenCount(total)
            return
        }
        const styles = window.getComputedStyle(labelEl)
        const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0
        const widths = tags.map((el) => el.offsetWidth)
        const prefix = [0]
        widths.forEach((w, i) => {
            prefix[i + 1] = prefix[i] + w
        })

        const fullWidth = prefix[total] + gap * Math.max(0, total - 1)
        if (fullWidth <= available) {
            setVisibleCount(total)
            setHiddenCount(0)
            return
        }

        let nextVisible = 0
        let nextHidden = total
        for (let count = total; count >= 0; count--) {
            const hidden = total - count
            let plusWidth = 0
            if (hidden > 0 && plusMeasureRef.current) {
                plusMeasureRef.current.textContent = `+${hidden}`
                plusWidth = plusMeasureRef.current.offsetWidth
            }
            const gaps = gap * Math.max(0, count - 1)
            const withPlus = hidden > 0 ? (count > 0 ? gap + plusWidth : plusWidth) : 0
            const needed = prefix[count] + gaps + withPlus
            if (needed <= available) {
                nextVisible = count
                nextHidden = hidden
                break
            }
        }
        if (nextVisible < 1 && total > 0) {
            nextVisible = 1
            nextHidden = total - nextVisible
        }
        setVisibleCount(nextVisible)
        setHiddenCount(nextHidden)
    }

    useLayoutEffect(() => {
        if (!enableResponsiveTags) return
        recalcVisibleCount()
    }, [displaySelected, isDisabled, className, enableResponsiveTags])

    useEffect(() => {
        if (!enableResponsiveTags || !labelContainerRef.current) return
        const observer = new ResizeObserver(() => recalcVisibleCount())
        observer.observe(labelContainerRef.current)
        return () => observer.disconnect()
    }, [displaySelected.length, enableResponsiveTags])

    const getSearchGroups = async (signal) => {
        if (getSpaceUsers || predefinedUsersList) {
            return
        }
        setLoader(true)
        let resp = await searchGroupByName(searchText, signal);
        if (signal?.aborted) {
            return
        }
        if (resp?.result?.length) {
            let users = resp.result;
            let listOfGroups = [];
            users.forEach(user => {
                if (selectedOptions.user.includes(user.email)) {
                    listOfGroups.unshift(user);
                } else {
                    listOfGroups.push(user);
                }
            })
            setAllFilteredUsersGroups(grps => grps.concat(users))
            setGroupList(listOfGroups)
            setFilteredGroupList(listOfGroups)
        }
        setLoader(false)
    }

    const getSearchUsers = async (signal) => {
        if (getSpaceUsers || predefinedUsersList) {
            return
        }
        setLoader(true)
        let results = [];
        try {
            let response = await axios({
                method: "GET",
                url: `${BACKEND_API}/users/${searchText}`,
                signal: signal,
                headers: {
                    tenantId: tenantId,
                },
            })
            if (response.status === 200) {
                results = response?.data?.result || []
            }
        }
        catch {

        }
        if (signal?.aborted) {
            return
        }
        if (results) {
            let users = results;

            let listOfUsers = [];
            users.forEach(user => {
                if (selectedOptions.user.includes(user.email)) {
                    listOfUsers.unshift(user);
                } else {
                    listOfUsers.push(user);
                }
            })
            setAllFilteredUsersGroups(grps => grps.concat(users))

            setUsersList(listOfUsers)
            setFilteredUserList(listOfUsers)
        }
        setLoader(false)

    }

    const getPredefinedList = () => {
        let listOfUsers = getSpaceSpecificUsers(spaceSpecificUsers, predefinedUsersList, selectedOptions, getSpaceUsers, predefinedGroupList)
        setUsersList(listOfUsers)
        setFilteredUserList(listOfUsers)
        let listOfGroups = getSpaceSpecificGroups(spaceSpecificGroups, predefinedGroupList, selectedOptions, getSpaceUsers, predefinedUsersList)
        setGroupList(listOfGroups)
        setFilteredGroupList(listOfGroups)
    }

    useEffect(() => {
        if (searchText.length >= 3) {
            return
        }
        if (predefinedUsersList || spaceSpecificUserPickers) {
            getPredefinedList();
        }
    }, [predefinedUsersList, predefinedGroupList, spaceSpecificUsers, searchText])

    useEffect(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        const controller = new AbortController()
        abortControllerRef.current = controller

        if (searchText.length >= 2) {
            if (searchLocal) {
                let reqSearchText = searchText.toLowerCase()
                if (activeTab === "user") {
                    let filteredUsers = userList.filter(user => user.email?.toLowerCase().includes(reqSearchText) || user.name?.toLowerCase().includes(reqSearchText))
                    setFilteredUserList(filteredUsers)
                    return reqSearchText = searchText.toLowerCase()
                }
                if (activeTab === "group") {
                    let filteredGroups = groupList.filter(group => group.email?.toLowerCase().includes(reqSearchText))
                    setFilteredGroupList(filteredGroups)
                    return
                }
            } else {
                if (activeTab === "user" && !getSpaceUsers && !predefinedUsersList) {
                    setLoader(true)
                    getSearchUsers(controller.signal);
                } else if (activeTab === "group" && !getSpaceUsers && !predefinedUsersList) {
                    setLoader(true)
                    getSearchGroups(controller.signal)
                }
            }
        } else {
            setLoader(false)
            if (!getSpaceUsers && !predefinedUsersList) {
                setFilteredGroupList([])
                setFilteredUserList([])
            }
        }
        return () => {
            controller.abort()
            setLoader(false)
        }
    }, [searchText])

    const hideDropdown = (e) => {
        if (customDropdownContainer && customDropdownContainer.current && !customDropdownContainer.current.contains(e.target)) {
            setShowDropdown(false)
            setSearchText("")
        }
    }

    const getRoles = () => {
        setLoader(true)
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_BACKEND_API}/role/${tenantId}`,
            headers: {
                userId: userInfo.userId || 1,
            },
        })
            .then((response) => {
                let data = response.data?.result || [];
                let reqData = []
                data.map(role => {
                    if (selectedOptions && selectedOptions?.role?.includes(role.role)) {
                        reqData.unshift(role);
                    } else {
                        reqData.push(role);
                    }
                })
                setRoleList(reqData)
                setLoader(false)
            })
            .catch((error) => {
                setLoader(false)
            });
    }

    useEffect(() => {
        // if(activeTab === "group" && groupList.length === 0) {
        //     getGroups();
        // }
        if (activeTab === 'role' && roleList.length === 0) {
            getRoles();
        }
    }, [activeTab])

    useEffect(() => {
        document.body.addEventListener("click", (e) => hideDropdown(e))
        return () => document.body.removeEventListener("click", (e) => hideDropdown(e))
    }, [])

    const activeTabHandler = (tab) => {
        setActiveTab(tab)
        setSearchText('')
        if (!getSpaceUsers) {
            setFilteredGroupList([])
            setFilteredUserList([])
        }
    }

    const getName = (value) => {
        let reqName = value
        if (!getSpaceUsers && !predefinedUsersList) {
            let reqObj = allFilteredUsersGroups.find(grp => grp.groupId === value || grp.email === value)
            return reqObj?.name || reqName
        }
        let currentUser = spaceSpecificUsers?.find(user => user.email === value)
        if (currentUser) {
            return currentUser?.name
        }
        let currentGroup = spaceSpecificGroups?.find(group => group.groupId === value)
        if (currentGroup) {
            return currentGroup?.name
        }
        let currentPicker = spaceSpecificUserPickers?.find(picker => picker.id === value);

        if (currentPicker) {
            return currentPicker?.label || value
        }
        let currentDropdown = formElements?.find(element => element.id === value)
        if (currentDropdown) {
            return currentDropdown?.label || value
        }
        return reqName
    }

    const getList = (list = []) => {
        let modList = [...list]
        let workUponKey = '', workUponSubKey = ''
        if (activeTab == "user") {
            workUponKey = "email"
            workUponSubKey = "name"
        } else if (activeTab == "role") {
            // workUponKey = "role"
            workUponSubKey = "role"
        } else if (activeTab == "group") {
            // workUponKey = "email"  // earlier email was there which was not satisying given condition
            workUponKey = "groupId"
            workUponSubKey = "name"
        } else if (activeTab === "userPicker") {
            modList = [...pickerList]
            workUponKey = "id"
            workUponSubKey = "label"
        } else if (activeTab === "dropdownItem") {
            modList = formElements.map(element => {
                return { label: element.label, id: element.id }
            })
            workUponKey = "id"
            workUponSubKey = "label"
        }
        if (searchText && list && list.length > 0) {
            if (activeTab === "user") {
                modList = modList.filter(a => {
                    let loweredName = a[workUponSubKey]?.toLowerCase() ?? ''
                    let loweredEmail = a[workUponKey]?.toLowerCase() ?? ''
                    let loweredSearchText = searchText.toLowerCase()
                    return loweredName.includes(loweredSearchText) || loweredEmail.includes(loweredSearchText)
                })
            } else {
                modList = modList.filter(a => {
                    let loweredA = a[activeTab === 'group' ? workUponSubKey : workUponKey]?.toLowerCase() ?? ''
                    let loweredSearchText = searchText.toLowerCase()
                    return loweredA.includes(loweredSearchText)
                })
            }

        }
        let noDataMessage = "No Data Found"
        if (activeTab == "user" || activeTab === "group") {
            noDataMessage = "Start typing in search box"
        }
        if (loader) {
            return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 100 }}><Spin spinning={true}></Spin></div>
        }

        if (modList && modList.length == 0) {
            return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 100, color: "#1677ff" }}>{noDataMessage}</div>
        }
        return (
            <Checkbox.Group onChange={(checkedValues) => handleTemplateUsers(activeTab, checkedValues)} value={selectedOptions[activeTab]}>
                <List
                    itemLayout="horizontal"
                    dataSource={modList}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={mode == "SINGLE" ? <Checkbox value={activeTab === 'role' ? item[workUponSubKey] : item[workUponKey]} /> : <Checkbox value={activeTab === 'role' ? item[workUponSubKey] : item[workUponKey]} />}
                                title={<div style={{
                                    textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", textAlign: "left"
                                }}><Tooltip title={item[workUponSubKey]}>{item[workUponSubKey]}</Tooltip></div>}
                                // {item[workUponSubKey]}
                                description={(activeTab === "user") ? <Tooltip title={item[workUponKey]} placement="top"><div style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", position: "relative", top: -5, fontWeight: "normal", textAlign: "left" }}>{item[workUponKey]}</div></Tooltip> : ""}
                            />
                        </List.Item>
                    )}
                />
            </Checkbox.Group>
        )
    }

    const handleTemplateUsers = (type, values) => {
        let reqSearchText = searchText?.toLowerCase() || ""

        if (onSelect) {
            if (type == "user") {
                let filteredUserList = [...userList]
                if (reqSearchText) {
                    filteredUserList = userList.filter(user => user.email?.toLowerCase().includes(reqSearchText) || user.name?.toLowerCase().includes(reqSearchText))
                }
                let selectedUsers = values.map(value => {
                    let userInfo = filteredUserList.find(user => user.email === value)
                    return { ...userInfo }
                })
                if (!getSpaceUsers) {
                    let allSelected = localStorage.getItem("spaceUsers") ? JSON.parse(localStorage.getItem("spaceUsers")) : []
                    localStorage.setItem("spaceUsers", JSON.stringify(selectedUsers.concat(allSelected)))
                }
                let selectedUsersFromPreviousList = selectedOptions.user.filter(r => {
                    let index = filteredUserList.findIndex(u => u.email == r)
                    if (index == -1) {
                        return true
                    } else {
                        return false
                    }
                })
                if (mode == "SINGLE") {
                    if (values.length == 0) {
                        onSelect({ ...selectedOptions, [activeTab]: [] }, { userList, roleList, groupList, pickerList })
                    } else {
                        let latest = values.filter(f => !selectedOptions.user.includes(f))
                        onSelect({ ...selectedOptions, [activeTab]: latest }, { userList, roleList, groupList, pickerList })
                    }
                } else {
                    onSelect({ ...selectedOptions, [activeTab]: [...selectedUsersFromPreviousList, ...values] }, { userList, roleList, groupList, pickerList })
                }
            } else {
                let arrayToFilter = [...groupList]
                let workUponKey = "groupId", subKey = "name"
                if (type === "role") {
                    workUponKey = "role"
                    subKey = "role"
                    arrayToFilter = [...roleList]
                } else if (type === "userPicker") {
                    workUponKey = "id"
                    subKey = "label"
                    arrayToFilter = [...pickerList]
                } else if (type === "dropdownItem") {
                    workUponKey = "id"
                    subKey = "label"
                    arrayToFilter = formElements.map(element => ({ id: element.id, label: element.label }))
                }
                if (reqSearchText) {
                    arrayToFilter = arrayToFilter.filter(data => data[subKey]?.toLowerCase().includes(reqSearchText))
                }
                let selectedOptionsType = selectedOptions[type] || []
                let selectedDataFromPreviousList = selectedOptionsType?.filter(r => {
                    let index = arrayToFilter.findIndex(u => u[workUponKey] == r)
                    if (index == -1) {
                        return true
                    } else {
                        return false
                    }
                })

                onSelect({ ...selectedOptions, [activeTab]: Array.from(new Set([...selectedDataFromPreviousList, ...values])) }, { userList, roleList, groupList, pickerList })
            }
        }
    }

    const onRemoveHandler = (data) => {
        let values = [...selectedOptions[data.type]]
        let indexFound = values.findIndex(v => v == data.display)
        if (indexFound != -1) {
            values.splice(indexFound, 1)
            if (onSelect) {
                onSelect({ ...selectedOptions, [data.type]: values })
            }
        }
    }

    return (
        <div className={`custom-dropdown-container ${className || ''}`} ref={customDropdownContainer} style={{ width: width, cursor: isDisabled ? "not-allowed" : "default" }} >
            <div className={`${displaySelected.length > 0 ? 'selected-label' : ''} top-dropdown-label ${isDisabled ? "disabled" : ""}`} onClick={(e) => { e.preventDefault(); setShowDropdown(!showDropdown) }} style={{ ...headerStyle }}>
                <div className="custom-dropdown-label" ref={enableResponsiveTags ? labelContainerRef : null}>
                    {!placeholderElement ? (displaySelected.length > 0 ? (
                        <>
                            {displaySelected.map((r, index) => {
                                if (enableResponsiveTags && index >= visibleCount) return null
                                return (
                                    <span key={r.display} data-type={r.type} style={{ display: "flex" }}>
                                        <Tooltip title={(r.type === "group" || r.type === "userPicker") ? getName(r.display) : r.display} placement={"top"}>
                                            <span className="email-display-span" style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: 120, display: "block" }}>{getName(r.display)}</span>
                                        </Tooltip>
                                        {!isDisabled && <CloseOutlined style={{ marginLeft: 5 }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onRemoveHandler(r) }} />}
                                    </span>
                                )

                            })}
                            {enableResponsiveTags && hiddenCount > 0 && (
                                <Tooltip
                                    title={displaySelected
                                        .slice(Math.max(visibleCount, 0))
                                        .map(r => (r.type === "userPicker" ? getName(r.display) : getName(r.display)))
                                        .join(", ")}
                                    placement="top"
                                >
                                    <span
                                        className="email-display-span extra-count"
                                        data-type={displaySelected[0]?.type}
                                        style={{ marginLeft: 6, display: "flex", alignItems: "center" }}
                                    >
                                        +{hiddenCount}
                                    </span>
                                </Tooltip>
                            )}
                        </>
                    ) : placeholder) : placeholderElement}
                </div>
                {enableResponsiveTags && (
                    <div className="custom-dropdown-measure" ref={measureContainerRef} aria-hidden="true">
                        {displaySelected.map((r, index) => (
                            <span key={`${r.display}-${index}`} data-type={r.type} data-measure-tag="true" style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                                <span className="email-display-span" style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: className?.includes("25") ? 140 : 206, display: "block" }}>
                                    {getName(r.display)}
                                </span>
                                {!isDisabled && <CloseOutlined style={{ marginLeft: 5 }} />}
                            </span>
                        ))}
                        <span ref={plusMeasureRef} className="custom-dropdown-more-count" data-measure-plus="true">+0</span>
                    </div>
                )}
                {
                    !hideDownArrow && <DownOutlined />
                }

            </div>
            {
                // nowheel/nopan keep React Flow from swallowing the wheel and drag events
                // when this panel is opened from inside a canvas node, so the list scrolls
                // instead of the canvas. Both classes are inert everywhere else.
                showDropdown && !isDisabled && (
                    <div className="custom-dropdown nowheel nopan" style={{ position: "absolute", ...dropdownStyle }}>
                        <div className="search-box"><Input prefix={<SearchOutlined style={{ color: "#00000073", width: "100%" }} />} value={searchText} placeholder={t("Search")} onChange={e => setSearchText(e.target.value)} /></div>
                        <div className="custom-dropdown-tabs">
                            {(tabsRequired && !tabsRequired.includes("user")) ? '' : <div data-active={activeTab == "user"} onClick={() => activeTabHandler("user")}>{t("User")}</div>}
                            {(tabsRequired && !tabsRequired.includes("role")) ? '' : <div data-active={activeTab == "role"} onClick={() => activeTabHandler("role")}>{t("Role")}</div>}
                            {(tabsRequired && !tabsRequired.includes("group")) ? '' : <div data-active={activeTab == "group"} onClick={() => activeTabHandler("group")}>{t("Group")}</div>}
                            {(tabsRequired && !tabsRequired.includes("userPicker")) ? '' : <div data-active={activeTab == "userPicker"} onClick={() => activeTabHandler("userPicker")}>{t("User Picker")}</div>}
                            {(tabsRequired && !tabsRequired.includes("dropdownItem")) ? '' : <div data-active={activeTab == "dropdownItem"} onClick={() => activeTabHandler("dropdownItem")}>{t("Form Item")}</div>}

                        </div>
                        <div className="custom-dropdown-list-container" key={"search-list-" + searchText}>
                            {
                                activeTab == "user" && getList(filteredUserList)
                            }
                            {
                                activeTab == "role" && getList(roleList)
                            }
                            {
                                activeTab == "group" && getList(filteredGroupList)
                            }
                            {
                                activeTab == "userPicker" && getList(pickerList)
                            }
                            {
                                activeTab == "dropdownItem" && getList(formElements)
                            }
                        </div>
                    </div>
                )
            }
        </div>

    )
}
export default UserRoleDropdown
